"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find-index.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _interface = require("../interface");
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../../_utils/hooks/usePrefixCls");
var _excluded = ["size", "color", "className", "style"]; // GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LinkIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('icon');
  var size = props.size,
    color = props.color,
    className = props.className,
    customStyle = props.style,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isFontSize = false;
  var isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = _interface.SizeTypes.findIndex(function (item) {
      return item === size;
    }) !== -1;
  }
  var classes = (0, _classnames.default)(prefixCls, prefixCls + '--' + 'link', (0, _defineProperty2.default)({}, 'size-' + size, isSize), className);
  var style = _objectSpread({
    color: color,
    fontSize: isFontSize ? size : undefined
  }, customStyle);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: style
  }, restProps, {
    height: "16px",
    width: "16px",
    version: "1.1",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("title", null, "link"), /*#__PURE__*/_react.default.createElement("g", {
    id: "link",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "\u8DEF\u5F84",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: "0.2",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.045,5.395 L9.9,8.54 C9.2934892,9.1446918 8.46647956,9.4756878 7.61024554,9.4564339 C6.75401151,9.4371799 5.94271632,9.0693437 5.364,8.438 C5.2920167,8.3803344 5.23219432,8.30895542 5.188,8.228 C5.184,8.223 5.178,8.218 5.175,8.213 L5.177,8.211 C5.02213534,7.91773421 5.07737345,7.55767575 5.31302916,7.32432136 C5.54868487,7.09096697 5.90926807,7.03926489 6.201,7.197 C6.221,7.177 6.417,7.373 6.521,7.477 L6.523,7.478 C7.162,8.118 8.193,8.123 8.833,7.483 L11.983,4.333 C12.6216915,3.69349107 12.6216915,2.65750893 11.983,2.018 L11.983,2.017 C11.3437195,1.3777568 10.3072805,1.3777568 9.668,2.017 L7.771,3.914 C7.11125613,3.59197555 6.34210674,3.58170555 5.674,3.886 L8.606,0.955 C9.8326306,-0.26972311 11.8193694,-0.26972311 13.046,0.955 C14.2701726,2.18185836 14.2701726,4.16814164 13.046,5.395 L13.045,5.395 Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.395,13.046 C4.16713637,14.2685207 2.18176177,14.2676264 0.955,13.044 C-0.268507532,11.817257 -0.268507532,9.831743 0.955,8.605 L4.1,5.459 C4.70654637,4.85398873 5.5337765,4.52278941 6.39026139,4.54204475 C7.24674629,4.56130009 8.05825621,4.92934125 8.637,5.561 C8.655,5.576 8.672,5.593 8.69,5.61 C8.73798263,5.65845267 8.77903779,5.71330505 8.812,5.773 C8.817,5.776 8.82,5.783 8.825,5.787 C8.824,5.788 8.823,5.788 8.823,5.79 C8.97814227,6.08298124 8.92312042,6.44299478 8.68755011,6.67626235 C8.45197979,6.90952992 8.09144315,6.96101272 7.8,6.803 C7.78,6.823 7.583,6.627 7.478,6.523 C7.17288193,6.2148458 6.757606,6.04088849 6.32395369,6.03957496 C5.89030138,6.03826143 5.47397924,6.20969983 5.167,6.516 L2.017,9.667 C1.377,10.307 1.377,11.342 2.017,11.982 L2.018,11.984 C2.65716596,12.6225769 3.69283404,12.6225769 4.332,11.984 L6.229,10.087 C6.88824694,10.4099432 7.65765309,10.4198545 8.325,10.114 L5.395,13.046 L5.395,13.046 Z"
  }))));
});
var _default = exports.default = LinkIcon;